import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {delivery} from "@/api/delivery";
import {retryRequest} from "@/helpers/request";

export const types = {
    product_choice: "product_choice",
    address_form: "address_form",
    pending_approvals: "pending_approvals"
};

export interface Survey {
    _id?: string
    type?: string
    [key: string]: unknown
}

export interface SurveyAnswer {
    survey_id: string
    [key: string]: unknown
}

export interface SurveysState {
    hide: string | null
    items: Survey[]
}

const surveys: Module<SurveysState, RootState> = {
    namespaced: true,
    state: {
        hide: null,
        items: [],
    },
    getters: {
        items: (state): Survey[] => state.items.filter(item => !item._id || item._id != state.hide)
    },
    mutations: {
        setItems: (state, items: Survey[]) => state.items = items,
        setHide: (state, hide: string | null) => state.hide = hide
    },
    actions: {
        fetch: context => retryRequest(() => delivery.get<{results: Survey[] | null}>("/adhoc-survey"))
            .then(response => context.commit("setItems", response.data.results || [])),
        view: (context, surveyId: string) => delivery.put(`/adhoc-survey/${surveyId}/views`, {}),
        post: (context, model: SurveyAnswer) => delivery.put(`/adhoc-survey/${model.survey_id}`, model),
        hide: (context, hide: string | null) => context.commit("setHide", hide),
        clear: context => context.commit("setItems", [])
    }
}

export default surveys
